import { render } from "./App.vue?vue&type=template&id=cf80cf12"
const script = {}
script.render = render

export default script